import { withStyles } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
const styles = (theme) => ({
  errorMessage: {
    color: theme.errorBorderColor,
    fontSize: theme.textFontSize,
    display: 'flex',
    alignItems: 'center',
    padding: '2px 0px'
  },
  iconStyle: {
    paddingRight: 4,
    fontSize: theme.headerTextFontSize
  }
});
const ProErrors = ({ errors, classes }) => {
  return (
    <div>
      {errors.map((error, index) => {
        return (
          <div key={index} className={classes.errorMessage}>
            <InfoIcon className={classes.iconStyle} />
            {error}
          </div>
        );
      })}
    </div>
  );
};
export default withStyles(styles)(ProErrors);
